import { ref, onBeforeUnmount } from "vue"

import * as pubNub from "@/services/pubNub.js"
import * as sentryReporter from "@/services/sentryReporter.js"

import { useConfigurationStore } from "@/store/configuration.js"

import { eventBus } from "@/plugins/eventBus.js"

const states = {
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED"
}

export const usePubNubSubscriptions = () => {
  const pubNubSubscriptions = ref([])
  const pubnubSubscriptionsState = ref(states.ACTIVE)

  onBeforeUnmount(() => unsubscribeFromAllChannels())

  const subscribeToChannel = (channelName) => {
    if (pubNubSubscriptions.value.includes(channelName)) {
      return
    }
    pubNub.subscribe(channelName)
    pubNubSubscriptions.value.push(channelName)

    const configurationStore = useConfigurationStore()
    if (channelName === configurationStore.configuration.pubnub.channel_livestream) {
      sentryReporter.reportMessage(`[LIVESTREAMING] subscribing ls channel ${configurationStore.configuration.pubnub.channel_livestream}`, {
        key: "livestreaming",
        value: "subscribing_channel"
      })
    }
  }

  const unsubscribeFromChannel = (channelName, { useBeacon } = {}) => {
    const index = pubNubSubscriptions.value.indexOf(channelName)
    if (index > -1) {
      pubNub.unsubscribe(channelName, { useBeacon })
      pubNubSubscriptions.value.splice(index, 1)

      const configurationStore = useConfigurationStore()
      if (channelName === configurationStore.configuration.pubnub.channel_livestream) {
        sentryReporter.reportMessage(`[LIVESTREAMING] unsubscribing ls channel ${configurationStore.configuration.pubnub.channel_livestream}`, {
          key: "livestreaming",
          value: "unsubscribing_channel"
        })
      }
    }
  }

  const unsubscribeFromAllChannels = () => {
    const configurationStore = useConfigurationStore()
    if (pubNubSubscriptions.value.includes(configurationStore.configuration.pubnub.channel_livestream)) {
      sentryReporter.reportMessage(`[LIVESTREAMING] unsubscribing ls channel ${configurationStore.configuration.pubnub.channel_livestream}`, {
        key: "livestreaming",
        value: "unsubscribing_channel"
      })
    }

    pubNubSubscriptions.value.forEach((channelName) => pubNub.unsubscribe(channelName))
    pubNubSubscriptions.value = []
  }

  const suspendChannelSubscriptions = () => {
    if (pubnubSubscriptionsState.value === states.SUSPENDED) {
      return
    }
    pubNubSubscriptions.value.forEach((channelName) => pubNub.unsubscribe(channelName))
    pubnubSubscriptionsState.value = states.SUSPENDED
  }

  const resumeChannelSubscriptions = () => {
    if (pubnubSubscriptionsState.value === states.ACTIVE) {
      return
    }

    pubNubSubscriptions.value.forEach((channelName) => pubNub.subscribe(channelName))
    pubnubSubscriptionsState.value = states.ACTIVE
    eventBus.$emit("pn-resume")
  }

  return {
    subscribeToChannel,
    unsubscribeFromChannel,
    unsubscribeFromAllChannels,
    suspendChannelSubscriptions,
    resumeChannelSubscriptions
  }
}
